<template>
  <div class="content">
    <div class="formularios">
      <v-window v-model="currentView">
        <v-window-item>
          <v-card-actions
            class="d-block"
            style="
              position: sticky;
              top: -20px;
              background-color: white;
              z-index: 1;
            "
          >
            <v-item-group v-model="currentStep" class="text-center" mandatory>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 0"
                  width="14.28%"
                >
                  <v-badge
                    color="error"
                    :content="tabErrors[0]"
                    :value="tabErrors[0] > 0"
                    inline
                  >
                    1 - Escopo
                  </v-badge>
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 1"
                  width="14.28%"
                >
                  <v-badge
                    color="error"
                    :content="tabErrors[1]"
                    :value="tabErrors[1] > 0"
                    inline
                  >
                    2 - Classificação
                  </v-badge>
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 2"
                  width="14.28%"
                >
                  <v-badge
                    color="error"
                    :content="tabErrors[2]"
                    :value="tabErrors[2] > 0"
                    inline
                  >
                    3 - Objetivos
                  </v-badge>
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 3"
                  width="14.28%"
                >
                  4 - Macro Etapa
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 4"
                  width="14.28%"
                >
                  5 - Atividades
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 5"
                  width="14.28%"
                >
                  <v-badge
                    color="error"
                    :content="tabErrors[5]"
                    :value="tabErrors[5] > 0"
                    inline
                  >
                    6 - Etapas e Resultados
                  </v-badge>
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
              <v-item v-slot="{ active }">
                <v-btn
                  dense
                  text
                  tile
                  :style="{ opacity: active ? 1 : 0.8 }"
                  @click="currentStep = 6"
                  width="14.28%"
                >
                  7 - Arquivos
                  <v-icon v-if="!canEdit" class="ml-3" small color="#999">
                    mdi-lock
                  </v-icon>
                </v-btn>
              </v-item>
            </v-item-group>
            <v-progress-linear
              rounded
              color="success"
              :value="((currentStep + 1) / 7) * 100"
            ></v-progress-linear>
          </v-card-actions>
          
        </v-window-item>
      </v-window>
      
      <div :class="`view`" v-if="currentStep == 0">
        <EscopoWindowLI 
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
          :isAgrupamento="isAgrupamento"
        ></EscopoWindowLI>
      </div>
      <div :class="`view`" v-if="currentStep == 1">
        <ClassificacaoWindowLI
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
        ></ClassificacaoWindowLI>
      </div>
      <div :class="`view`" v-if="currentStep == 2">
        <ObjetivosWindowLI
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
        ></ObjetivosWindowLI>
      </div>
      <div :class="`view`" v-if="currentStep == 3">
        <MacroEtapaWindowLI
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
        >          
        </MacroEtapaWindowLI>
      </div>
      <div :class="`view`" v-if="currentStep == 4">
        <AtividadesWindowLI
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
        ></AtividadesWindowLI>
      </div>
      <div :class="`view`" v-if="currentStep == 5">      
        <ResultadosWindowLI
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
        ></ResultadosWindowLI>  
      </div>
      <div :class="`view`" v-if="currentStep == 6">      
        <ArquivosWindowLI
          :projeto="projeto"
          :canEdit="canEdit"
          :canEditStatus="canEditStatus"
          :isClient="isClient"
          :cliente="cliente"
          :hasAccessPlurianual="!this.userHasAccessToAction('plurianual')"
          :opts="opts"
          :anexos.sync="anexosLocal"
          :anexoTransmissao.sync="anexoTransmissaoLocal"
          :anexoComprobatorio.sync="anexoComprobatorioLocal"
          :anexoComprobatorioTerceiro.sync="anexoComprobatorioTerceiroLocal"
          :anexoCronogramaLi.sync="anexoCronogramaLiLocal"
          :anexoAnalise="projeto.anexo_analise || []"
        ></ArquivosWindowLI>  
      </div>
    </div>
  </div>
</template>

<script>
import { StatusProjetoEnum } from '@/core/enums/projetos';
import fields from './LIEnquadrados.fields';
import { mapGetters } from 'vuex';
import { AnyAdmin } from '@/core/enums/user-types';



import { isStrictProject, getProjectErrors } from '@/helpers/projectValidators';

export default {

  props: {
    projeto: {
      type: Object,
      required: true
    },
    anexos: {
      type: Array,
      default: () => []
    },
    anexoTransmissao: {
      type: Array,
      default: () => []
    },
    anexoComprobatorio: {
      type: Array,
      default: () => []
    },
    anexoComprobatorioTerceiro: {
      type: Array,
      default: () => []
    },
    anexoCronogramaLi: {
      type: Array,
      default: () => []
    },
    isAgrupamento: {
      type: Boolean,
      default: false
    },
    opts: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    EscopoWindowLI: () => import('./components/EscopoWindowLI.vue'),
    ClassificacaoWindowLI: () => import('./components/ClassificacaoWindowLI.vue'),
    ObjetivosWindowLI: () => import('./components/ObjetivosWindowLI.vue'),
    MacroEtapaWindowLI: () => import('./components/MacroEtapaWindowLI.vue'),
    AtividadesWindowLI: () => import('./components/AtividadesWindowLI.vue'),
    ResultadosWindowLI: () => import('./components/ResultadosWindowLI.vue'),
    ArquivosWindowLI: () => import('./components/ArquivosWindowLI.vue'),
  },
  data() {
    return {
      currentView: 0,
      currentStep: 0,
      fields,
    }
  },
  computed: {
    ...mapGetters(["clientId", "jwtData", "user"]),
    anexosLocal: {
      get() {
        return this.anexos;
      },
      set(value) {
        this.$emit('update:anexos', value);
      }
    },
    anexoTransmissaoLocal: {
      get() {
        return this.anexoTransmissao;
      },
      set(value) {
        this.$emit('update:anexoTransmissao', value);
      }
    },
    anexoComprobatorioLocal: {
      get() {
        return this.anexoComprobatorio;
      },
      set(value) {
        this.$emit('update:anexoComprobatorio', value);
      }
    },
    anexoComprobatorioTerceiroLocal: {
      get() {
        return this.anexoComprobatorioTerceiro;
      },
      set(value) {
        this.$emit('update:anexoComprobatorioTerceiro', value);
      }
    },
    anexoCronogramaLiLocal: {
      get() {
        return this.anexoCronogramaLi;
      },
      set(value) {
        this.$emit('update:anexoCronogramaLi', value);
      }
    },
    canEdit: function () {
      const { status } = this.projeto;
      const { tipo_usuario } = this.user;
      // Se 'Em Revisão Galapos' ou 'Em validação final Galapos' somente Galapos pode editar
      // Aprovado para Submissão ou Submetido - ninguém pode editar, mas consultor ainda pode alterar o status
      return (
        ![
          StatusProjetoEnum.APROVADO_SUBMISSAO,
          StatusProjetoEnum.SUBMETIDO,
        ].includes(status) &&
        (![
          StatusProjetoEnum.REVISAO_GALAPOS,
          StatusProjetoEnum.VALIDACAO_FINAL_GALAPOS,
        ].includes(status) ||
          AnyAdmin.includes(tipo_usuario))
      );
    },
    canEditStatus: function () {
      const { status } = this.projeto;
      const { tipo_usuario } = this.user;

      // Aprovado para Submissão ou Submetido - ninguém pode editar, mas consultor ainda pode alterar o status
      return (
        this.canEdit ||
        ([
          StatusProjetoEnum.APROVADO_SUBMISSAO,
          StatusProjetoEnum.SUBMETIDO,
        ].includes(status) &&
          AnyAdmin.includes(tipo_usuario))
      );
    },
    isClient: function () {
      return this.getClient().isClient;
    },
    cliente: function() {
      return this.opts.clientes.filter((c) => c.id == this.projeto.empresaId)[0] || {
        trabalho: 0
      };
    },
    tabErrors() {
       const isStrict = isStrictProject(this.projeto);
       const escopoFields = this.isAgrupamento
         ? this.fields.escopo.filter(f => f.key !== 'titulo_transmissao')
         : this.fields.escopo;
       return {
         0: getProjectErrors(this.projeto, escopoFields, isStrict),
         1: getProjectErrors(this.projeto, this.fields.classificacao, isStrict),
         2: getProjectErrors(this.projeto, this.fields.objetivos, isStrict),
         3: 0,
         4: 0,
         5: getProjectErrors(this.projeto, this.fields.resultados, isStrict),
       };
    },
  },

  watch: {
    currentStep(val) {
      if (this.projeto && this.projeto.id) {
        localStorage.setItem(`LI_TAB_${this.projeto.id}`, val);
      }
    },
    'projeto.id': {
      handler(val) {
        if (val) {
          this.restoreTab();
          this.$store.dispatch('projetos/fetchProjectComments', {
            empresaId: this.projeto.empresaId,
            projetoId: val
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    restoreTab() {
      if (this.projeto && this.projeto.id) {
        const storedTab = localStorage.getItem(`LI_TAB_${this.projeto.id}`);
        if (storedTab !== null) {
          const step = parseInt(storedTab, 10);
          if (!isNaN(step) && step >= 0 && step <= 6) {
            this.currentStep = step;
          }
        }
      }
    }
  },
  created() {
    this.restoreTab();
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style lang="scss">
</style>